import { ApolloError } from '@apollo/client';
import { Center, Spinner, Table, Text } from '@chakra-ui/react';
import { useTranslate } from '@tolgee/react';
import { useEffect, useState } from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';
import ApplicationErrorView from '@packages/charka-common-ui/graphql/error/application-error-view';
import { PrintRule } from '../print-rule';

export default function PrintRuleTable(props: {
  printRules: PrintRule[] | undefined;
  printRuleAssigmentId: string | null;
  loading: boolean;
  error?: ApolloError;
}) {
  const { printRules, loading, error } = props;
  const { t } = useTranslate();
  const navigate = useNavigate();

  const [searchParams] = useSearchParams();

  const [selection, setSelection] = useState<PrintRule | null>(null);

  useEffect(() => {
    setSelection(printRules?.find((item) => item.id == props.printRuleAssigmentId) ?? null);
  }, [printRules, props.printRuleAssigmentId]);

  if (loading) {
    return (
      <Center>
        <Spinner />
      </Center>
    );
  }

  if (error) {
    return <ApplicationErrorView error={error} />;
  }

  if (!printRules) {
    return <Text>{t('print-rule.alert.error', 'Something went wrong with print rule data')}</Text>;
  }

  const rows = printRules.map((item) => (
    <Table.Row key={item.name} data-selected={selection?.id == item.id ? '' : undefined}>
      <Table.Cell>
        {/* <AssignmentCheckBoxDialog */}
        {/*   checked={selection?.id == item.id} */}
        {/*   onCheck={(item: PrintRule | null) => { */}
        {/*     setSelection(item); */}
        {/*   }} */}
        {/*   item={item} */}
        {/* /> */}
      </Table.Cell>
      <Table.Cell
        onClick={() => {
          navigate(`rule/${item.id}?service=${searchParams.get('service') ?? ''}`);
        }}
      >
        {item.name}
      </Table.Cell>
    </Table.Row>
  ));

  return (
    <>
      <Table.Root size="lg" interactive>
        <Table.Header>
          <Table.Row bgColor={'bg.subtle'}>
            <Table.ColumnHeader w={12} fontWeight={600}>
              {t('print-rule.table.default')}
            </Table.ColumnHeader>
            <Table.ColumnHeader fontWeight={600}>{t('print-rule.table.name')}</Table.ColumnHeader>
          </Table.Row>
        </Table.Header>

        <Table.Body>{rows}</Table.Body>
      </Table.Root>
    </>
  );
}
